import NoticeApi from '../../api/NoticeApi';
import { useState, useEffect } from 'react';
import PageNavigation from '../pageNavigation/PageNavigation';
import { getDate } from '../../common/util';
import { Outlet, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

const pageOptions = [
    { key: 30, value: 30, text: '30개씩 보기', active: true, selected: true },
    { key: 50, value: 50, text: '50개씩 보기', active: false, selected: false },
    { key: 100, value: 100, text: '100개씩 보기', active: false, selected: false },
];

const Notice = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [list, setList] = useState([]);
    const [curPage, setCurPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [pageCount, setPageCount] = useState(30);
    const [isLoading, setIsLoading] = useState(false);

    const init = (page = curPage, count = pageCount, keyword = '') => {
        setIsLoading(true);
        NoticeApi.getNoticeList({ page, count, keyword }).then(rslt => {
            const { data: { list, totalCount } } = rslt;
            console.log('list', list);
            setList(list);
            setCurPage(page);
            setTotalCount(totalCount);
            setIsLoading(false);
        });
    }
   
    const handlePageChange = page => {
        if (page === curPage) return;
        setCurPage(page);
        init(page);
    }

    const handleCountSelect = (e, data) => {
        setPageCount(data.value);
    }

    const handleKeyDown = event => {
        if (event.keyCode === 13) {
            init(undefined, undefined, event.target.value);
        }
    };

    const handleItemClick = item => {
        console.log('item', item);
        navigate(`/notice/${item.id}`);
    }

    useEffect(() => {
        init();
    }, []);


    return (
        <div className="vh-content-wrap">
            <div className="content-header">
				<h1>공지사항</h1>
				<h2>최신 공지사항을 확인할 수 있습니다.</h2>
			</div>
            {!id && <div className="content">
                <div className="filter-area">
                    <div className="filter-search">
                        <div className="field-search">
                            <input 
                                placeholder="제목" 
                                onKeyDown={handleKeyDown}
                            />
                            <button type="button" onClick={handleKeyDown}>
                                <i className="icon icon-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="table-area">
                    <table className="sortable">
                        <colgroup>
                            <col width="4%" />
                            <col width="" />
                            <col width="7%" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th className="sorttable_nosort">번호	</th>
                                <th className="sorttable_nosort">제목</th>
                                <th className="sorttable_nosort">작성일자</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list.map(item => <tr key={`notice_${item.id}`} className="clickable" onClick={() => handleItemClick(item)}>
                                <td>{item.id}</td>
                                <td>{item.title}</td>
                                <td>{getDate(item.reg_date)}</td>
                            </tr>)}
                        </tbody>
                    <tfoot></tfoot></table>
                </div>

                <div className="table-nav">
                    <PageNavigation totalCount={totalCount} showCount={pageCount} onChange={handlePageChange} />
                    <div className="table-nav-row">
                        <div>
                            <select onChange={handleCountSelect}>
                                {pageOptions.map(option => (
                                    <option key={option.key} value={option.value}>{option.text}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>}
            <Outlet />
        </div>
    )
}

export default Notice;